export const filterOwnerSuburbOptions = (options, country) => {
    const suburbs = Array.isArray(options) ? options : [];
    const isNewZealand = String(country ?? "").trim().toLowerCase() === "new zealand";
    return suburbs.filter(option => {
        const isNzSuburb = (option?.search_state || option?.state) === "NZ";
        return isNewZealand ? isNzSuburb : !isNzSuburb;
    });
};
